export type DownloadProgressCb = (loaded: number, total?: number) => void;

export const PROGRESS_REPORT_INTERVAL_MS = 1000;

export function countBytesThrough(
  body: ReadableStream<Uint8Array>,
  total: number | undefined,
  onProgress: DownloadProgressCb,
  intervalMs = PROGRESS_REPORT_INTERVAL_MS,
): ReadableStream<Uint8Array> {
  let loaded = 0;
  let lastReport = 0;
  return body.pipeThrough(
    new TransformStream<Uint8Array, Uint8Array>({
      transform(chunk, controller) {
        loaded += chunk.byteLength;
        const now = Date.now();
        if (now - lastReport >= intervalMs) {
          lastReport = now;
          onProgress(loaded, total);
        }
        controller.enqueue(chunk);
      },
      flush() {
        onProgress(loaded, total);
      },
    }),
  );
}

export function parseContentLength(header: string | null): number | undefined {
  const size = Number(header);
  return Number.isFinite(size) && size > 0 ? size : undefined;
}
